import React from "react";

export function Logo({ className = null, style = null }) {
  return <img src="/logo.png" style={style} className={className} />;
}
